'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FooterCard;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spacer = require('../Spacer');

var _Spacer2 = _interopRequireDefault(_Spacer);

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _P = require('../P');

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'card': 'ccl-8669d6ff19b2ab67',
  'inner': 'ccl-2c790a1c497db6e5',
  'list': 'ccl-0ddab7743dba827b',
  'listItem': 'ccl-958ecea4d2731a0b',
  'link': 'ccl-070cf49b78b2413d'
};

/**
 * A Card containing links to be displayed in the global Footer
 */

function FooterCard(_ref) {
  var heading = _ref.heading,
      links = _ref.links,
      children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: styles.card },
    _react2.default.createElement(
      'div',
      { className: styles.inner },
      _react2.default.createElement(
        _Spacer2.default,
        { spacing: 'large' },
        _react2.default.createElement(
          _Heading2.default,
          { level: 3, size: 'x-small', color: 'white', spacing: '0 0 small 0' },
          heading
        ),
        links.length > 0 && _react2.default.createElement(
          'ul',
          { className: styles.list },
          links.map(function (_ref2) {
            var text = _ref2.text,
                url = _ref2.url;
            return _react2.default.createElement(
              'li',
              { key: url, className: styles.listItem },
              _react2.default.createElement(
                _P2.default,
                { color: 'white', size: 'small' },
                _react2.default.createElement(
                  'a',
                  { href: url, className: styles.link },
                  text
                )
              )
            );
          })
        ),
        children
      )
    )
  );
}

FooterCard.displayName = 'FooterCard';
FooterCard.propTypes = {
  /**
   * Heading text for the FooterCard
   */
  heading: _propTypes2.default.string.isRequired,

  /**
   * An array of links
   */
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired
  })),

  /**
   * Optional additional child content, rendered after the list of links (if any)
   */
  children: _propTypes2.default.node
};

FooterCard.defaultProps = {
  links: [],
  children: undefined
};